var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { State, Action, Selector } from '@ngxs/store';
import { StoryLabelsStateModel } from './story.labels.state.model';
import { AddLabel, RemoveLabel, SetLabels, SelectLabel, SetLabel, RemoveAllChapterLabels, CopyLabels, RemoveAllLabels, ResetLabels, ConvertLabels, AddContextLabel, EnableContextLabel, RemoveContextLabel } from './story.labels.actions';
import { uuid } from 'src/app/shared/uuid';
import { StoryChaptersState } from '../chapters/story.chapters.state';
import { StoryChaptersStateModel } from '../chapters/story.chapters.state.model';
import { LabelsService } from '../../labels.service';
import { LabelRecipe } from '../../models/labels/label-recipe.enum';
import * as _ from 'lodash';
import { FlyToChapterErrandModel } from '../../models/errands/fly-to-chapter-errand.model';
import { FlyToObjectErrandModel } from '../../models/errands/fly-to-object-errand.model';
var initialState = {
    enableContextLabel: true,
    loading: false,
    labels: [],
    contextLabel: null,
    selectedLabel: null
};
var StoryLabelsState = /** @class */ (function () {
    function StoryLabelsState(labelsService) {
        this.labelsService = labelsService;
    }
    /**
     * Selectors
     */
    StoryLabelsState.getLabels = function (state) {
        return state.labels;
    };
    StoryLabelsState.getSelectedLabel = function (state) {
        return state.labels.find(function (label) { return label.id === state.selectedLabel; }) || null;
    };
    StoryLabelsState.getContextLabel = function (state) {
        return state.contextLabel;
    };
    StoryLabelsState.getChapterLabels = function (state, storyChaptersState) {
        return state.labels.filter(function (label) { return label.chapterId === storyChaptersState.selectedChapter; });
    };
    StoryLabelsState.getEnableContextLabel = function (state) {
        return state.enableContextLabel;
    };
    /**
     * Actions
     */
    StoryLabelsState.prototype.setLabels = function (context, action) {
        context.patchState({
            labels: action.labels
        });
    };
    StoryLabelsState.prototype.setLabel = function (context, action) {
        var labels = context.getState().labels;
        var labelIndex = labels.findIndex(function (_label) { return _label.id === action.label.id; });
        labels[labelIndex] = __assign({}, action.label);
        context.patchState({
            labels: __spread(labels)
        });
    };
    StoryLabelsState.prototype.addLabel = function (context, action) {
        action.label.id = action.label.id || uuid.idWithPrefix('label');
        var labels = context.getState().labels;
        context.patchState({
            labels: __spread(labels, [__assign({}, action.label)])
        });
    };
    StoryLabelsState.prototype.addContextLabel = function (context, action) {
        var label = __assign({}, action.label);
        label.id = 'context-label';
        context.patchState({
            contextLabel: label
        });
    };
    StoryLabelsState.prototype.copyLabels = function (context, action) {
        var labels = context.getState().labels;
        var sourceLabels = labels.filter(function (label) { return label.chapterId === action.sourceChapter.id; });
        var targetLabels = sourceLabels.map(function (label) {
            return __assign({}, (_.cloneDeep(label)), { id: uuid.idWithPrefix('label'), chapterId: action.targetChapter.id });
        });
        context.patchState({
            labels: __spread(labels, targetLabels)
        });
    };
    StoryLabelsState.prototype.removeLabel = function (context, action) {
        var labels = context.getState().labels
            .filter(function (label) {
            return label.id !== action.label.id;
        });
        context.patchState({
            labels: __spread(labels)
        });
        Human.scene.markers.delete(action.label.id);
    };
    StoryLabelsState.prototype.RemoveContextLabel = function (context, action) {
        context.patchState({
            contextLabel: null
        });
        Human.scene.markers.delete('context-label');
    };
    StoryLabelsState.prototype.removeAllLabels = function (context, action) {
        var labels = context.getState().labels;
        // Remove labels from the engine
        labels.forEach(function (label) {
            Human.scene.markers.delete(label.id);
        });
        // Update application state
        context.patchState({
            labels: []
        });
    };
    StoryLabelsState.prototype.removeAllChapterLabels = function (context, action) {
        var labels = context.getState().labels;
        var chapterLabels = labels.filter(function (label) { return label.chapterId === action.chapter.id; });
        var filteredLabels = labels.filter(function (label) { return label.chapterId !== action.chapter.id; });
        // Remove labels from the engine
        chapterLabels.forEach(function (label) {
            Human.scene.markers.delete(label.id);
        });
        // Update application state
        context.patchState({
            labels: __spread(filteredLabels)
        });
    };
    StoryLabelsState.prototype.selectLabel = function (context, action) {
        context.patchState({
            selectedLabel: action.label ? action.label.id : null
        });
    };
    StoryLabelsState.prototype.resetLabels = function (context, action) {
        context.dispatch(new RemoveAllLabels());
        context.dispatch(new RemoveContextLabel());
        context.setState(initialState);
    };
    StoryLabelsState.prototype.convertLabels = function (context, action) {
        var _this = this;
        var labels = context.getState().labels;
        action.labels.forEach(function (label) {
            var index = labels.findIndex(function (_label) { return _label.id === label.id; });
            switch (action.type) {
                case LabelRecipe.StudioNext:
                    labels[index] = _this.labelsService.makeDefaultStudioLabel(labels[index]);
                    if (label.objectId) {
                        labels[index].states[0].errands[0] = new FlyToChapterErrandModel();
                        labels[index].states[1].errands[0] = new FlyToObjectErrandModel(label.objectId);
                    }
                    break;
                case LabelRecipe.Annotation:
                    labels[index] = _this.labelsService.makeAnnotationLabel(labels[index]);
                    break;
            }
        });
        context.patchState({
            labels: __spread(labels)
        });
    };
    StoryLabelsState.prototype.enableContextLabel = function (context, action) {
        context.patchState({
            enableContextLabel: action.enable
        });
    };
    __decorate([
        Action(SetLabels),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetLabels]),
        __metadata("design:returntype", void 0)
    ], StoryLabelsState.prototype, "setLabels", null);
    __decorate([
        Action(SetLabel),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetLabel]),
        __metadata("design:returntype", void 0)
    ], StoryLabelsState.prototype, "setLabel", null);
    __decorate([
        Action(AddLabel),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, AddLabel]),
        __metadata("design:returntype", void 0)
    ], StoryLabelsState.prototype, "addLabel", null);
    __decorate([
        Action(AddContextLabel),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, AddContextLabel]),
        __metadata("design:returntype", void 0)
    ], StoryLabelsState.prototype, "addContextLabel", null);
    __decorate([
        Action(CopyLabels),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, CopyLabels]),
        __metadata("design:returntype", void 0)
    ], StoryLabelsState.prototype, "copyLabels", null);
    __decorate([
        Action(RemoveLabel),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, RemoveLabel]),
        __metadata("design:returntype", void 0)
    ], StoryLabelsState.prototype, "removeLabel", null);
    __decorate([
        Action(RemoveContextLabel),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, RemoveContextLabel]),
        __metadata("design:returntype", void 0)
    ], StoryLabelsState.prototype, "RemoveContextLabel", null);
    __decorate([
        Action(RemoveAllLabels),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, RemoveLabel]),
        __metadata("design:returntype", void 0)
    ], StoryLabelsState.prototype, "removeAllLabels", null);
    __decorate([
        Action(RemoveAllChapterLabels),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, RemoveAllChapterLabels]),
        __metadata("design:returntype", void 0)
    ], StoryLabelsState.prototype, "removeAllChapterLabels", null);
    __decorate([
        Action(SelectLabel),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SelectLabel]),
        __metadata("design:returntype", void 0)
    ], StoryLabelsState.prototype, "selectLabel", null);
    __decorate([
        Action(ResetLabels),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ResetLabels]),
        __metadata("design:returntype", void 0)
    ], StoryLabelsState.prototype, "resetLabels", null);
    __decorate([
        Action(ConvertLabels),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ConvertLabels]),
        __metadata("design:returntype", void 0)
    ], StoryLabelsState.prototype, "convertLabels", null);
    __decorate([
        Action(EnableContextLabel),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, EnableContextLabel]),
        __metadata("design:returntype", void 0)
    ], StoryLabelsState.prototype, "enableContextLabel", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryLabelsStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryLabelsState, "getLabels", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryLabelsStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryLabelsState, "getSelectedLabel", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryLabelsStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryLabelsState, "getContextLabel", null);
    __decorate([
        Selector([StoryChaptersState]),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryLabelsStateModel, StoryChaptersStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryLabelsState, "getChapterLabels", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryLabelsStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryLabelsState, "getEnableContextLabel", null);
    StoryLabelsState = __decorate([
        State({
            name: 'labels',
            defaults: initialState
        }),
        __metadata("design:paramtypes", [LabelsService])
    ], StoryLabelsState);
    return StoryLabelsState;
}());
export { StoryLabelsState };
